import { useState, useCallback } from 'react';
import {
  getMarketingConsent,
  setMarketingConsent,
  hasConsentDecision,
  type ConsentValue,
} from '@/lib/analytics';

/**
 * React hook for marketing cookie consent.
 * Returns current state and helpers to accept/decline.
 */
export function useMarketingConsent() {
  const [consent, setConsent] = useState<ConsentValue>(() => getMarketingConsent());
  const [decided, setDecided] = useState(() => hasConsentDecision());

  const accept = useCallback(() => {
    setMarketingConsent('granted');
    setConsent('granted');
    setDecided(true);
  }, []);

  const decline = useCallback(() => {
    setMarketingConsent('denied');
    setConsent('denied');
    setDecided(true);
  }, []);

  /** Re-open the banner so the user can change their choice */
  const reset = useCallback(() => {
    if (typeof window !== 'undefined') {
      localStorage.removeItem('prepframe_marketing_consent');
    }
    setConsent(null);
    setDecided(false);
  }, []);

  return { consent, decided, accept, decline, reset };
}
